import { FormControl, FormHelperText, InputLabel, OutlinedInput } from "@mui/material";
import { forwardRef, useCallback, useEffect, useState } from "react";
import { IMaskInput } from "react-imask";

/**
 * CPFMaskedInputBase
 */
interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  mask: string;
}

const CPFMaskedInputBase = forwardRef<HTMLInputElement, CustomProps>((props, refs) => {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      placeholder="_"
      inputRef={refs}
      onAccept={(value: any, input: { unmaskedValue: string }) => {
        if (input.unmaskedValue.length > 0) {
          onChange({ target: { name: props.name, value } });
        } else {
          onChange({ target: { name: props.name, value: '' } });
        }
      }}
      lazy={false}
      overwrite={true}
    />
  );
});


/**
 * CPFMaskedInput
 */

type Props = {
  name: string,
  label: string,
  error?: boolean,
  helperText?: string,
  value?: string;
  placeholder?: string;
  unmask?: boolean;
  onChange: (value: string) => void,
};

export const CPFMaskedInput = ({
  name,
  label,
  error,
  helperText,
  value,
  placeholder,
  unmask,
  onChange,
}: Props) => {
  const [fieldValue, setFieldValue] = useState(value);

  useEffect(() => {
    setFieldValue(value);
  }, [
    value,
  ]);

  const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(event.target.value);
    onChange(event.target.value);
  }, [onChange]);

  return (
    <FormControl variant="outlined" size="small">
      <InputLabel htmlFor={`input-${name}`} shrink={true} size="small" error={error}>{label}</InputLabel>
      <OutlinedInput
        size="small"
        id={`input-${name}`}
        name={name}
        value={fieldValue}
        label={label}
        notched={true}
        error={error}
        aria-describedby={`${name}-component-error-text`}
        onChange={handleChange}
        inputComponent={CPFMaskedInputBase as any}
        inputProps={{
          mask: '000.000.000-00',
          placeholder: placeholder ?? '_',
          unmask,
        }}
      />

      <FormHelperText id={`${name}-component-error-text`} error={true}>
        {helperText}
      </FormHelperText>
    </FormControl>
  );
}